export const DASHBOARD_URL = '/dashboard';
export const LADNING_URL = '/';
 export const baseURL = process.env.REACT_APP_API_BASE_URL;

export const apiBaseURL = `${baseURL}/api`;



// END Point Constants
export const SEARCH_DECISION_MAKERS = "/search/decision-makers";
export const SEARCH_TASK_BY_ID = '/search/tasks/';